import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import usePartnerFilters from '../../partners/components/PartnerFilterHelper';
import { useGetPartnersHandler } from '../dataHandlers/getPartnersHandler';
import { Controller } from 'react-hook-form';

const PartnersSelectField = ({
  label = 'Partner',
  name,
  control,
  errors,
  readOnly = false,
  onPartnersLoaded,
  disabled = false,
}) => {
  const { currentQuery, handleSearchChange } = usePartnerFilters({
    defaultQuery: {},
    searchOnChange: true,
  });

  const { partners, isLoading } = useGetPartnersHandler({ searchQuery: currentQuery });

  useEffect(() => {
    if (partners) {
      onPartnersLoaded?.(partners);
    }
  }, [partners, onPartnersLoaded]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const resolvedValue = partners?.find((p) => p.id === (field.value?.id ?? field.value)) ?? null;

        return (
          <Box display="flex" alignItems="flex-start" gap={2}>
            <Autocomplete
              loading={isLoading}
              {...field}
              id={name}
              fullWidth
              readOnly={readOnly}
              options={partners || []}
              getOptionLabel={(option) => `${option?.name || ''} | ${option?.email || ''} `} // TODO: Check for the company_id
              getOptionKey={(option) => option?.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  error={!!errors[name]}
                  helperText={errors[name]?.message}
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    },
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value?.id} // Compare unique IDs
              onChange={(_, value) => field.onChange(value)}
              value={resolvedValue}
              disabled={disabled}
              onInputChange={(_, value, reason) => {
                if (reason === 'input') {
                  handleSearchChange(value);
                }
              }}
              filterOptions={(x) => x}
            />
          </Box>
        );
      }}
    />
  );
};

export default PartnersSelectField;
